import React from "react";
import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";
import { OnTabKeyPress } from "../../../../../../utils/cssUtils";

export const VisionScreenTest = (props) => {
  const stackedFieldStyle = {
    layout: "stacked",
    showContainerBorder: false,
    labelWrap: false,
    isLabel: true,
  };
  const visionHistoryRadioStyle = {
    ...stackedFieldStyle,
    appendElmtClass: "ms-4",
    labelStyle: { whiteSpace: "nowrap" },
    optionLabelStyle: { fontWeight: "normal" },
  };
  const visionHistoryAlignWithRadio = {
    col: "col-12 border-0 ms-2",
    appendElmtClass: "ms-3",
    appendClass: "ms-3",
  };
  const visionHistoryQuestionLabel = (
    <>
      4. History Of Eye Disease That Affects Vision?
      <br />
      <span style={{ fontSize: "0.95em", display: "block", marginLeft: "0.75rem" }}>
        (e.g. glaucoma, cataracts, macular degeneration, diabetic retinopathy)
      </span>
    </>
  );
  const charts = [
    {
      type: "Grid",
      col: "col-md-3",
    //   className: "non-dot-exam-scrollable",
      style: {
        position: "sticky",
        top: "0",
        zIndex: "1",
        height: "calc(100vh - 200px)",
        overflowY: "auto",
        overflowX: "hidden",
      },
      data: [
        {
          type: "PatientDetails",
          employeeDetails: props.employeeDetails,
          visitDetails: props.visitDetails,
        },
        {
          type: "CompanyDetails",
          companyDetails: props.companyDetails,
        },
      ],
    },
    {
      type: "Tab",
      col: "col-md-9",
      data: [
        {
          id: "History1",
          label: "History",
          data: [
            {
              label: "Vision Medical History",
              labelStyle: "fw-semibold",
              cardBodyClassName: "pl-0",
              fields: [
                {
                  label: "1. Do You Normally Wear Glasses Or Contacts?",
                  ...visionHistoryRadioStyle,
                  type: "radioBoxGroup",
                  col: "col-12 border-0",
                  name: "wear_glasses_contacts",
                  id: "wear_glasses_contacts",
                  options: [
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" },
                    { label: "Glasses", value: "Glasses" },
                    { label: "Contacts", value: "Contacts" },
                    { label: "Both", value: "Both" },
                  ],
                },
                {
                  label: "2. Are You Wearing Them Today For The Test?",
                  ...visionHistoryRadioStyle,
                  type: "radioBoxGroup",
                  col: "col-12 border-0",
                  name: "wearing_today",
                  id: "wearing_today",
                  options: [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 0 },
                  ],
                },
                {
                  label:
                    "3. Any Symptoms Today (Pain, Redness, Drainage, Blurred Vision, Flashes/Floaters, Double Vision)?",
                  ...visionHistoryRadioStyle,
                  type: "radioBoxGroup",
                  col: "col-12 border-0",
                  name: "symptoms_today",
                  id: "symptoms_today",
                  options: [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 0 },
                  ],
                },
                {
                  label: "Describe",
                  isLabel: false,
                  col: "col-12 border-0",
                  type: "TextInput",
                  placeholder: "Describe",
                  name: "symptoms_describe",
                  id: "symptoms_describe",
                  ...visionHistoryAlignWithRadio,
                },
                {
                  label: visionHistoryQuestionLabel,
                  ...visionHistoryRadioStyle,
                  labelStyle: { whiteSpace: "normal" },
                  type: "radioBoxGroup",
                  col: "col-12 border-0",
                  name: "eye_disease_history",
                  id: "eye_disease_history",
                  showContainerBorder: false,
                  options: [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 0 },
                  ],
                },
                {
                  label: "Describe",
                  isLabel: false,
                  col: "col-12 border-0",
                  type: "TextInput",
                  placeholder: "Describe",
                  name: "eye_disease_describe",
                  id: "eye_disease_describe",
                  ...visionHistoryAlignWithRadio,
                },
                {
                  label: "5. Eye Surgery/Injury In The Last 3 Months?",
                  ...visionHistoryRadioStyle,
                  type: "radioBoxGroup",
                  col: "col-12 border-0",
                  name: "eye_surgery_injury",
                  id: "eye_surgery_injury",
                  options: [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 0 },
                  ],
                },
                {
                  label: "Describe",
                  isLabel: false,
                  col: "col-12 border-0",
                  type: "TextInput",
                  placeholder: "Describe",
                  name: "eye_surgery_describe",
                  id: "eye_surgery_describe",
                  ...visionHistoryAlignWithRadio,
                },
              ],
            },
           {
                    label:'Patient Signature & Comments',
                     labelStyle: "fw-semibold",
                    col:'col-12',
                    fields:[
                         {
                           label: 'Comments',
                           type: 'TextArea',
                           placeholder: 'Content',
                           name: 'patient_comments',
                           id: 'patient_comments',
                           col: 'col-md-6 col-12 border-0',
                           layout: 'stacked',
                           labelStyle: { paddingLeft: '0.75rem' },
                           style: { minHeight: '150px', resize: 'vertical' },
                           rows: 5,
                         },
                         {
                           label: "Signature",
                           type: 'NewSignature',
                           isLabel: false,
                           col: 'col-md-6 col-12 border-0',
                           name: 'driver_signature',
                           id: 'driver_signature',
                           required: true,
                         },
                    ]
                },
          ],
        },
        {
          id: "exam",
          label: "Exam",
          data: [
            {
              label: "Vision Exam",
              labelStyle: "fw-semibold",
              fields: [
                {
                  label: "Is vision corrected or uncorrected?",
                  col: "col-12 border-0",
                  type: "RadioGroup",
                  name: "wearing_corrective_lenses",
                  id: "wearing_corrective_lenses",
                  options: [
                    { label: "Corrected", value: 1 },
                    { label: "Uncorrected", value: 0 },
                  ],
                  appendElmtClass: "d-flex justify-content-end",
                },
                {
                  label: 'VISION',
                  type: 'Label',
                  col: 'col-3 sh_vision_table_header_bg text-vision-heading fw-bold py-2',
                  border: false,
                },
                {
                  label: 'UNCORRECTED',
                  type: 'Label',
                  col: 'col-3 sh_vision_table_header_bg text-vision-heading fw-bold py-2',
                  border: false,
                },
                {
                  label: 'CORRECTED',
                  type: 'Label',
                  col: 'col-3 sh_vision_table_header_bg text-vision-heading fw-bold py-2',
                  border: false,
                },
                {
                  label: 'HORIZONTAL FIELD OF VISION',
                  type: 'Label',
                  col: 'col-3 sh_vision_table_header_bg text-vision-heading fw-bold py-2',
                  appendClassLabel: 'text-nowrap',
                  border: false,
                },
                                // --- ROW 1: LEFT ---
                                {
                                   label: 'Left eyes',
                                   type: 'Label', 
                                   col: 'col-3 border-0 d-flex text-dark  align-items-center', // Vertically center the text
                                },
                                {
                                   label: '',
                                   isLabel: false,
                                   name: 'uncorrected_left_eye',
                                   id: 'uncorrected_left_eye',
                                   col: 'col-3 border-0',
                                   isNumeric: true,
                                  //  rangeMax: 40,
                                   max:2,
                                   rules:[
                                       {rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'SHOW'},
                                       {rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'CLEAR'}
                                   ],
                                   onKeyPress: (event) => OnTabKeyPress(event, "uncorrected_right_eye", ""),
                                   
                        },
                        {
                            label: '',
                            isLabel: false,
                            name: 'corrected_left_eye',
                            id: 'corrected_left_eye',
                            col: 'col-3 border-0',
                            isNumeric: true,
                            // rangeMax: 40,
                            max:2,
                            rules:[
                                {rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'},
                                {rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'CLEAR'}
                            ],
                            onKeyPress: (event) => OnTabKeyPress(event, "corrected_right_eye", "wearing_corrective_lenses"),
                           
                        },{
                            label: '',
                            isLabel: false,
                            type: 'Number',
                            name: 'horizontal_field_of_vision_left_eye',
                            id: 'horizontal_field_of_vision_left_eye',
                            col: 'col-3 border-0',
                            // placeholder: 'Degrees',
                            isNumeric: true,
                            // rangeMin: 70,
                            // rangeMax: 90,
                            max:3,  // DOT normal max
                 
                            // rules:[{rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'CLEAR'}],
                            onKeyPress: (event) => OnTabKeyPress(event, "horizontal_field_of_vision_right_eye", "horizontal_field_of_vision_right_eye"),
                            
                        },
                
                        // --- ROW 2: RIGHT ---
                        {
                            label: 'Right eyes',
                            type: 'Label',
                            col: 'col-3 border-0 text-dark d-flex align-items-center',
                        },
                        {
                            label: '',
                            isLabel: false,
                            name: 'uncorrected_right_eye',
                            id: 'uncorrected_right_eye',
                            col: 'col-3 border-0',
                            isNumeric: true,
                            // rangeMax: 40,
                            max:2,
                            rules:[
                                {rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'SHOW'},
                                {rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'CLEAR'}
                            ],
                            onKeyPress: (event) => OnTabKeyPress(event, "uncorrected_both_eyes", "uncorrected_left_eye"),
                            
                        },
                        {
                            label: '',
                            isLabel: false,
                            name: 'corrected_right_eye',
                            id: 'corrected_right_eye',
                            col: 'col-3 border-0',
                            isNumeric: true,
                            // rangeMax: 40,
                            max:2,
                            rules:[
                                {rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'},
                                {rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'CLEAR'}
                            ],
                            onKeyPress: (event) => OnTabKeyPress(event, "corrected_both_eyes", "corrected_left_eye"),
                            
                        },
                        {
                            label: '',
                            isLabel: false,
                            type: 'Number',
                            name: 'horizontal_field_of_vision_right_eye',
                            id: 'horizontal_field_of_vision_right_eye',
                            col: 'col-3 border-0',
                            // placeholder: 'Degrees',
                            isNumeric: true,
                            // rangeMin: 70,
                            // rangeMax: 90, 
                            max:3,  // DOT normal max
                
                            // rules:[{rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'CLEAR'}],
                            // onKeyPress: (event) => OnTabKeyPress(event, "corrected_both_eyes" || "horizontal_field_of_vision_left_eye", "corrected_right_eye"),
                           
                        },
                
                        // --- ROW 3: BOTH ---
                        {
                            label: 'Both eyes',
                            type: 'Label',
                            col: 'col-3 border-0 text-dark d-flex align-items-center',
                        },
                        {
                            label: '',
                            isLabel: false,
                            name: 'uncorrected_both_eyes',
                            id: 'uncorrected_both_eyes',
                            col: 'col-3 border-0',
                            isNumeric: true,
                            // rangeMax: 40,
                            max:2,
                            rules:[
                                {rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'SHOW'},
                                {rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'CLEAR'}
                            ],
                            onKeyPress: (event) => OnTabKeyPress(event, "horizontal_field_of_vision_left_eye", "uncorrected_right_eye"),
                            
                        },
                        {
                            label: '',
                            isLabel: false,
                            name: 'corrected_both_eyes',
                            id: 'corrected_both_eyes',
                            col: 'col-3 border-0',
                            isNumeric: true,
                            // rangeMax: 40,
                            max:2,
                            rules:[
                                {rule:[{field:'wearing_corrective_lenses',value:1,operator:'==='}],action:'SHOW'},
                                {rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'CLEAR'}
                            ],
                            onKeyPress: (event) => OnTabKeyPress(event, "horizontal_field_of_vision_left_eye", "uncorrected_both_eyes"),
                            
                        },
                        {
                            label: '',
                            type: 'Label',
                            col: 'col-3 border-0',
                        },
              ],
            },
            {
              label: "Color Recognition",
              labelStyle: "fw-semibold",
              fields: [
                {
                  label:
                    "Applicant can recognize and distinguish among traffic control signals and devices showing red, green, and amber colors?",
                  col: "col-12 border-0",
                  type: "RadioGroup",
                  name: "color_recognition_traffic_signals",
                  id: "color_recognition_traffic_signals",
                  options: [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 0 },
                  ],
                  appendElmtClass: "d-flex justify-content-end",
                },
                {
                  label: "Color Vision",
                  type: "TextInput",
                  name: "color_vision",
                  id: "color_vision",
                  col: "col-md-6 col-12 border-0",
                  placeholder: "Content",
                  layout: "stacked",
                  ...stackedFieldStyle,
                },
                {
                  label: "Depth Perception",
                  type: "TextInput",
                  name: "depth_perception",
                  id: "depth_perception",
                  col: "col-md-6 col-12 border-0",
                  placeholder: "Content",
                  layout: "stacked",
                  ...stackedFieldStyle,
                },
                {
                  label: "Far Point Lateral Phoria",
                  type: "TextInput",
                  name: "far_point_lateral_phoria",
                  id: "far_point_lateral_phoria",
                  col: "col-md-6 col-12 border-0",
                  placeholder: "Content",
                  layout: "stacked",
                  ...stackedFieldStyle,
                },
                {
                  label: "Far Point Vertical Phoria",
                  type: "TextInput",
                  name: "far_point_vertical_phoria",
                  id: "far_point_vertical_phoria",
                  col: "col-md-6 col-12 border-0",
                  placeholder: "Content",
                  layout: "stacked",
                  ...stackedFieldStyle,
                },
                {
                  label: "Near Point Lateral Phoria",
                  type: "TextInput",
                  name: "near_point_lateral_phoria",
                  id: "near_point_lateral_phoria",
                  col: "col-md-6 col-12 border-0",
                  placeholder: "Content",
                  layout: "stacked",
                  ...stackedFieldStyle,
                },
                {
                  label: "Near Point Vertical Phoria",
                  type: "TextInput",
                  name: "near_point_vertical_phoria",
                  id: "near_point_vertical_phoria",
                  col: "col-md-6 col-12 border-0",
                  placeholder: "Content",
                  layout: "stacked",
                  ...stackedFieldStyle,
                },
              ],
            },
            {
              label: "Review / Completion",
              labelStyle: "fw-semibold",
              fields: [
                {
                  type: "ProviderSignOff",
                  col: "col-12",
                  fields: [
                    {
                      label: "Signature PIN",
                      placeholder: "Signature PIN",
                      name: "provider_pin",
                      col: "col-12",
                    },
                    {
                      label: "Signature",
                      type: "NewSignature",
                      name: "provider_signature",
                      col: "col-12",
                    },
                    {
                      label: "Date",
                      type: "Date",
                      name: "signed_date",
                      col: "col-12",
                    },
                    {
                      label: "Final Results",
                      type: "SelectList",
                      name: "status",
                      col: "col-12",
                      // Previous options:
                      // options: isSet(props.lookupsOptions?.["chartResult"], []),
                      // New standard options:
                      options: optionsToKeyValuePairs(
                        [
                          "Not Started",
                          "Pending",
                          "Normal",
                          "Abnormal",
                          "Negative",
                          "Positive",
                          "Dispensed",
                          "Administered",
                          "Failed",
                          "Passed",
                          "Non-Negative",
                          "Cancelled",
                          "Inconclusive",
                        ],
                        false
                      ),
                      statusBasedColor: true,
                    },
                    {
                      label: "Activity Status",
                      type: "SelectList",
                      name: "activity_status",
                      col: "col-12",
                      // Previous options:
                      // options: optionsToKeyValuePairs([
                      //   "Not Started",
                      //   "Ordered",
                      //   "Completed",
                      //   "Cancelled",
                      // ]),
                      // New standard options:
                      options: optionsToKeyValuePairs(
                        [
                          "Not Started",
                          "Pending",
                          "Pending Lab Confirmation",
                          "Pending MRO Confirmation",
                          "Ready for Review",
                          "Completed",
                          "Cancelled",
                        ],
                        false
                      ),
                      statusBasedColor: true,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "Images",
          label: "Images",
          data: [],
        },
      ],
    },
  ];
  const defaultValue = {
    status: "Not Started",
    suggested_status: "Not Started",
    activity_status: "Not Started",
    vision_result: "Not Started",
  };
  const headers = [];
  return {
    charts,
    defaultValue,
    headers,
    computationFunction: (formData, key) => computationRules1(formData, key),
  };
};

// Commented out existing computation rules - now using shared computationRules1 from DrugScreenCollection.js
/*
// No linked updates: Final Results is manual (like PulmonaryFunction).
const computationRules = (formData, key) => {
  return {};
};
*/
